import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { translate } from 'components/Translation';
import { Switch, Route } from 'react-router-dom';
import NumbersList from 'views/Numbers/NumbersList';
import Details from 'views/Numbers/Details';

interface IIndexProps {
	match: {
		path: string;
	};
}

const Numbers = ({ match }: IIndexProps) => {
	return (
		<>
			<BreadcrumbsItem to="/dashboard/numbers">
				{`${translate('path.my.services')} - ${translate('path.my.numbers')}`}
			</BreadcrumbsItem>
			<Switch>
				<Route path={match.path} exact render={(props: any) => <NumbersList {...props} />} />
				<Route
					path={`${match.path}/:phoneNumberEncoded/:accountNumber/:accountType(MOBILE|FIX|INTERNET|WFBB)/:billingType(POSTPAID|PREPAID)/:upAccountId/:subpage(number-details|usage|bills|services|sim-management|settings|active-commitments|aamali-services)?`}//aamali-plus-services is aamali plus services
					render={(props: any) => <Details {...props} />}
				/>
			</Switch>
		</>
	);
};

export default Numbers;
